import { useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext'
import ThreeDotsLoading from '../components/primitives/ThreeDotsLoading';
import { useTranslation } from '../hooks/useTranslation';

export default function RegisterDiscord() {
    const t = useTranslation();
    const { getAuthToken, url } = useAuth();

    async function handleDiscordRegister() {
        try {
            const token = await getAuthToken();
            if (!token)
                throw new Error("Failed to get token");
            window.location.href = `${url}/discord/install?JPChatToken=${token}`;
        } catch(error) {
            console.log("Failed to register workspace")
        }
    }

    useEffect(() => {
        handleDiscordRegister();
    }, []);

    return (
        <div className="analytics-container">
            <h1>{t('Registering with {{platform}}', { platform: 'Discord' })}</h1>
            <ThreeDotsLoading />
        </div>
    )
}